import { general } from './general';

export const radio = (data = {}) => general('radio', (data || {}));
